<template>
  <div class="header-wrapper">
    <div class="top-bar">
      <div class="container">
        <div class="top-bar-content">
          <div class="contact-info">
            <span class="phone">品牌咨询与设计</span>
            <span class="tel">13606083580</span>
          </div>
        </div>
      </div>
    </div>
    <el-header class="header">
      <div class="container header-content">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          text-color="#fff"
          active-text-color="#fff"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item v-if="menuConfig.cases !== false" index="/cases">作品案例</el-menu-item>
          <el-menu-item v-if="menuConfig.brandCase !== false" index="/brand-case">品牌全案</el-menu-item>
          <el-menu-item v-if="menuConfig.services !== false" index="/services">服务项目</el-menu-item>
          <el-menu-item v-if="menuConfig.brandUpgrade !== false" index="/brand-upgrade">品牌升级</el-menu-item>
          <el-menu-item v-if="menuConfig.thinkTank !== false" index="/think-tank">豪禾智库</el-menu-item>
          <el-menu-item v-if="menuConfig.about !== false" index="/about">关于豪禾</el-menu-item>
          <el-menu-item v-if="menuConfig.contact !== false" index="/contact">联系我们</el-menu-item>
        </el-menu>
      </div>
    </el-header>
  </div>
</template>

<script>
import { getMenuConfig } from '@/api/menu'

export default {
  name: 'Header',
  data() {
    return {
      activeIndex: '/',
      menuConfig: {
        cases: true,
        brandCase: true,
        services: true,
        brandUpgrade: true,
        thinkTank: true,
        about: true,
        contact: true
      }
    }
  },
  watch: {
    $route(to) {
      this.activeIndex = to.path
    }
  },
  mounted() {
    this.activeIndex = this.$route.path
    this.loadMenuConfig()
  },
  methods: {
    // 加载页签显示配置
    loadMenuConfig() {
      getMenuConfig()
        .then(response => {
          if (response.code === 200 && response.data) {
            // 合并配置，如果后端返回了配置则使用，否则使用默认值
            this.menuConfig = {
              cases: response.data.cases !== undefined ? response.data.cases : true,
              brandCase: response.data.brandCase !== undefined ? response.data.brandCase : true,
              services: response.data.services !== undefined ? response.data.services : true,
              brandUpgrade: response.data.brandUpgrade !== undefined ? response.data.brandUpgrade : true,
              thinkTank: response.data.thinkTank !== undefined ? response.data.thinkTank : true,
              about: response.data.about !== undefined ? response.data.about : true,
              contact: response.data.contact !== undefined ? response.data.contact : true
            }
          }
        })
        .catch(error => {
          console.error('获取页签配置失败:', error)
          // 如果接口失败，使用默认配置（全部显示）
        })
    },
    handleSelect(key) {
      if (key !== this.$route.path) {
        this.$router.push(key)
      }
    }
  }
}
</script>

<style scoped>
.header-wrapper {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.top-bar {
  background: #fff;
  padding: 0;
  font-size: 12px;
  color: #333;
  height: 50px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}

.top-bar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.top-bar-content {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 50px;
}


.contact-info {
  display: flex;
  gap: 20px;
  align-items: center;
  height: 50px;
  line-height: 50px;
}

.phone {
  color: #666;
  font-size: 13px;
  font-weight: 400;
}

.tel {
  color: #333;
  font-weight: 600;
  font-size: 14px;
  font-family: Arial, "Microsoft YaHei", sans-serif;
}

.header {
  padding: 0;
  height: 60px !important;
  line-height: 60px;
  background: #EA4043;
}

.header-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
  flex-wrap: nowrap;
  overflow: hidden;
}

.el-menu-demo {
  width: 100%;
  display: flex;
  justify-content: center;
}

.el-menu-demo >>> .el-menu {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
}


.el-menu--horizontal {
  border-bottom: none !important;
  background: transparent;
}

.el-menu-demo >>> .el-menu {
  border-bottom: none !important;
}

.el-menu-demo >>> .el-menu--horizontal {
  border-bottom: none !important;
}

.el-menu-demo >>> .el-menu--horizontal .el-menu-item {
  border-bottom: none !important;
}

.el-menu-demo >>> .el-menu--horizontal .el-menu-item.is-active {
  border-bottom: none !important;
}

.el-menu--horizontal .el-menu-item {
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  padding: 0 22px;
  color: #fff;
  border-bottom: none !important;
  transition: all 0.3s ease;
  white-space: nowrap;
  flex-shrink: 0;
  font-weight: 400;
  position: relative;
  background: transparent !important;
}

.el-menu--horizontal .el-menu-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background-color: #fff;
  transition: width 0.3s ease, left 0.3s ease, transform 0.3s ease;
}

.el-menu--horizontal .el-menu-item:hover {
  background: transparent !important;
  color: #fff;
}

.el-menu--horizontal .el-menu-item:hover::after {
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 10px);
}

.el-menu--horizontal .el-menu-item.is-active {
  color: #fff;
  background: transparent !important;
  border-bottom: none !important;
}

.el-menu-demo >>> .el-menu-item.is-active {
  border-bottom: none !important;
}

.el-menu-demo >>> .el-menu-item {
  border-bottom: none !important;
}

.el-menu--horizontal .el-menu-item.is-active::after {
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 10px);
}

@media (max-width: 768px) {
  .top-bar {
    height: 40px;
  }
  
  .top-bar-content {
    height: 40px;
    justify-content: center;
  }
  
  .contact-info {
    height: 40px;
    line-height: 40px;
    gap: 10px;
    flex-direction: column;
    gap: 2px;
  }
  
  .phone,
  .tel {
    font-size: 11px;
    line-height: 1.2;
  }
  
  .header {
    height: auto !important;
  }
  
  .header-content {
    flex-direction: column;
    height: auto;
    padding: 8px 0;
  }
  
  .el-menu--horizontal .el-menu-item {
    height: 45px;
    line-height: 45px;
    padding: 0 12px;
    font-size: 14px;
  }
}
</style>
